import request from '@/api/request.js'

// 组群管理 #
// 新增组群接口
export function groupAdd(data) {
  return request({
      url: '/ops/group',
      method: 'post',
      data
  })
}
// 删除组群接口
export function groupDelete(params) {
  return request({
      url: '/ops/group/'+params.groupId,
      method: 'delete'
      // params: params
  })
}
// 更新组群接口
export function groupUpdate(data) {
  return request({
    url: '/ops/group/'+data.groupId,
    method: 'put',
    data
  })
}

// 查询组群接口
export function groupSearch(params) {
  return request({
    url: '/ops/group/'+params.groupId,
    method: 'get'
    // params: params
  })
}

// 查询组群列表接口
export function groupList(token) {
  return request({
    url: '/ops/group/page',
    method: 'get',
    params: token
  })
}

// 列表查询组群最大回显200条
export function groupListSelect(token) {
  return request({
    url: '/ops/group/list',
    method: 'get',
    params: token
  })
}

export function listUsersByGroupId(groupId) {
  return request({
    url: '/ops/group/user/list/'+groupId,
    method: 'get'
  })
}

// 查询组群信息接口
export function groupAllList() {
  return request({
    url: '/ops/group/list',
    method: 'get'
  })
}


